import angular from 'angular';


let AppService = function($rootScope) {
    var timer;

    return {
        loading : function() {
            clearTimeout(timer);
            $rootScope.status = 'loading';
            if(!$rootScope.$$phase) $rootScope.$apply();
        },
        ready : function(delay) {

            function ready() {
                $rootScope.status = 'ready';
                if(!$rootScope.$$phase) $rootScope.$apply();
            }

            clearTimeout(timer);
            delay = delay === null ? 500 : false;
            if(delay) {
                timer = setTimeout(ready, delay);
            }
            else {
                ready();
            }
        },
        isReady : function() {
            return $rootScope.status === 'ready';
        }
    };
}

AppService.$inject = [ '$rootScope' ];

export default angular.module("app.services", []).service("appServices", AppService).name;


// WEBPACK FOOTER //
// ./js/legacy/app/services.js